/**
 * Optimizes image URLs for better performance
 * - Unsplash: uses w/q/fm params for responsive sizing
 * - Supabase: returns as-is (no transform API on free plan)
 */

/**
 * Gets optimized image URL for trip cards (max 800px wide for cards)
 */
export const getTripCardImage = (url: string): string => {
  if (!url) return '';
  
  // Optimize Unsplash images: reduce to 800w, quality 75, webp format
  if (url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=800&q=75&fm=webp&fit=crop`;
  }
  
  return url;
};

/**
 * Generates srcset for responsive Unsplash images
 */
export const getTripCardSrcSet = (url: string): string => {
  if (!url || !url.includes('unsplash.com')) return '';
  
  const baseUrl = url.split('?')[0];
  return [
    `${baseUrl}?w=400&q=70&fm=webp&fit=crop 400w`,
    `${baseUrl}?w=800&q=75&fm=webp&fit=crop 800w`,
  ].join(', ');
};

/**
 * Gets thumbnail image URL (small, fast)
 */
export const getThumbnailImage = (url: string): string => {
  if (!url) return '';
  
  if (url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=300&q=60&fm=webp&fit=crop`;
  }
  
  return url;
};

/**
 * Gets hero/cover image URL (full size but optimized)
 */
export const getHeroImage = (url: string): string => {
  if (!url) return '';
  
  if (url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=1200&q=80&fm=webp&fit=crop`;
  }
  
  return url;
};

/**
 * Returns the original Supabase Storage URL without transformations
 */
export const optimizeSupabaseImage = (url: string): string => {
  return url || '';
};
